document.addEventListener('DOMContentLoaded', function() {
    // only desktop
    if (window.innerWidth < 768) return;

    // create preview container
    const previewContainer = document.createElement('div');
    previewContainer.className = 'collection-preview';
    document.body.appendChild(previewContainer);
    
    // handle menu item hover
    const menuItems = document.querySelectorAll('.menu-item-with-preview');
    
    menuItems.forEach(item => {
        // create preview element for each menu item
        const preview = item.querySelector('.collection-preview') || document.createElement('div');
        preview.className = 'collection-preview';
        
        const image = item.dataset.collectionImage;
        const description = item.dataset.collectionDescription;
        const url = item.dataset.collectionUrl;
        const title = item.dataset.collectionTitle;
        
        if (image && description) {
            preview.innerHTML = `
                ${image ? `<img src="${image}" alt="${title || ''}">` : ''}
                ${title ? `<h4>${title}</h4>` : ''}
                <p>${description}</p>
                ${url ? `<a href="${url}" class="view-collection">View Collection →</a>` : ''}
            `;
            
            // only append if not already a child
            if (!item.contains(preview)) {
                item.appendChild(preview);
            }
        }
        
        // show/hide preview on hover
        item.addEventListener('mouseenter', function() {
            if (image && description) {
                const rect = this.getBoundingClientRect();
                const viewportWidth = window.innerWidth;
                
                // position the preview
                preview.style.display = 'block';
                
                // check if preview would go off-screen to the right
                if (rect.right + 300 > viewportWidth) {
                    preview.style.left = 'auto';
                    preview.style.right = '100%';
                    preview.style.marginLeft = '0';
                    preview.style.marginRight = '10px';
                } else {
                    preview.style.left = '100%';
                    preview.style.right = 'auto';
                    preview.style.marginLeft = '10px';
                    preview.style.marginRight = '0';
                }
                
                // adjust if preview would go off-screen to the bottom
                const previewHeight = preview.offsetHeight;
                const spaceBelow = window.innerHeight - rect.bottom;
                
                if (previewHeight > spaceBelow) {
                    preview.style.top = 'auto';
                    preview.style.bottom = '0';
                } else {
                    preview.style.top = '0';
                    preview.style.bottom = 'auto';
                }
            }
        });
        
        item.addEventListener('mouseleave', function() {
            preview.style.display = 'none';
        });
    });
    
    // handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (window.innerWidth < 768) {
                document.querySelectorAll('.collection-preview').forEach(el => {
                    el.style.display = 'none';
                });
            }
        }, 250);
    });
});
